import Model from 'core/model/Model';

export default class CloudExportAzureSpn extends Model {
  get urlRoot() {
    return '/api/ui/cloudExportAzureSpn';
  }
}
